import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: _vm.fullscreenLoading,
      expression: "fullscreenLoading",
      modifiers: {
        fullscreen: true,
        lock: true
      }
    }]
  }, [_c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_vm.isAuth ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("保存")]) : _vm._e(), _c("div", {
    staticClass: "fr"
  }, [_c("el-link", {
    staticClass: "link",
    attrs: {
      target: "_blank",
      href: _vm.downLoadTemplate
    }
  }, [_vm._v("下载模板")]), _vm.isAuth ? _c("cpsc-file-import", {
    staticClass: "d2-mr-10",
    on: {
      change: _vm.uploadTemplate
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini"
    }
  }, [_vm._v("导入配置")])], 1) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "base-info"
  }, [_c("el-row", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("公司名称: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.form.name))])])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("公司简称: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.form.shortName))])])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("域名: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.form.domain))])])])], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("系统租期: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.productInfo.startDate, "yyyy-MM-dd")) + " - " + _vm._s(_vm._f("date")(_vm.productInfo.endDate, "yyyy-MM-dd")))])])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("最大用户数: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.productInfo.maxUser))])])]), _c("el-col", {
    attrs: {
      span: 8
    }
  }, [_c("div", [_c("span", {
    staticClass: "label"
  }, [_vm._v("注册日期: ")]), _c("span", {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.form.createDate)))])])])], 1)], 1), _c("div", {
    staticClass: "form-content"
  }, [_c("el-form", {
    ref: "form",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-width": "100px",
      "label-position": "left",
      size: "mini"
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "租户图标(深)",
      prop: "logo1Id"
    }
  }, [_vm.imageSrc1 ? _c("img", {
    staticClass: "upload-pre-image",
    attrs: {
      src: _vm.imageSrc1
    }
  }) : _vm._e(), _c("el-upload", {
    ref: "imageSrc1",
    staticClass: "avatar-uploader",
    attrs: {
      "http-request": _vm.upload,
      action: "",
      data: {
        name: "imageSrc1",
        Type: 0,
        logo: "logo1Id"
      },
      "before-upload": _vm.beforeUpload,
      accept: ".jpg, .jpeg, .png",
      "show-file-list": false
    }
  }, [_vm.isAuth ? _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    }
  }, [_vm._v("点击上传")]) : _vm._e()], 1)], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "租户图标(浅)",
      prop: "logo2Id"
    }
  }, [_vm.imageSrc2 ? _c("img", {
    staticClass: "upload-pre-image",
    attrs: {
      src: _vm.imageSrc2
    }
  }) : _vm._e(), _c("el-upload", {
    ref: "imageSrc2",
    staticClass: "avatar-uploader",
    attrs: {
      "http-request": _vm.upload,
      action: "",
      data: {
        name: "imageSrc2",
        Type: 2,
        logo: "logo2Id"
      },
      "before-upload": _vm.beforeUpload,
      accept: ".jpg, .jpeg, .png",
      "show-file-list": false
    }
  }, [_vm.isAuth ? _c("el-button", {
    attrs: {
      size: "mini",
      type: "primary"
    }
  }, [_vm._v("点击上传")]) : _vm._e()], 1)], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "联系人",
      prop: "contact.name"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入联系人"
    },
    model: {
      value: _vm.form.contact.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form.contact, "name", $$v);
      },
      expression: "form.contact.name"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机",
      prop: "contact.phone"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入手机"
    },
    model: {
      value: _vm.form.contact.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form.contact, "phone", $$v);
      },
      expression: "form.contact.phone"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "邮箱",
      prop: "contact.email"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入邮箱"
    },
    model: {
      value: _vm.form.contact.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form.contact, "email", $$v);
      },
      expression: "form.contact.email"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "注册省市区",
      prop: "pca"
    }
  }, [_c("el-cascader", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      options: _vm.options,
      props: _vm.optionsProps,
      expandTrigger: "hover"
    },
    model: {
      value: _vm.form.pca,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pca", $$v);
      },
      expression: "form.pca"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "注册地址",
      prop: "address"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入注册地址"
    },
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1)], 1), _c("el-col", {
    attrs: {
      span: 12
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "联系地址",
      prop: "postalAddress"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入联系地址"
    },
    model: {
      value: _vm.form.postalAddress,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "postalAddress", $$v);
      },
      expression: "form.postalAddress"
    }
  })], 1)], 1)], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };